// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._uid__container___3eXZb,._uid__heroContainer___304k_{max-width:inherit;padding:0 24px}._uid__heroContainer___304k_{margin:-64px 0 64px;background-color:#fff4ee;background-repeat:no-repeat;background-position:100% 100%;background-size:660px}._uid__heroContainer___304k_ p{padding-bottom:81px;color:#6b6651;font-size:20px;line-height:32px}@media (max-width:959px){._uid__heroContainer___304k_{background-size:300px}}._uid__inner___1SEg_{display:flex;min-height:350px;padding-top:144px}._uid__innerSlices___kGjrc{padding-bottom:64px}._uid__title___1Ntby{max-width:840px}._uid__title___1Ntby h1{max-width:725px;margin-bottom:16px;font-weight:200;font-size:32px;line-height:48px}@media (min-width:960px){._uid__title___1Ntby h1{font-size:52px;line-height:64px}}._uid__bottomSection___5OXj8{max-width:100%;height:419px;background:url(https://images.prismic.io/luko/a1fbc345-7436-419e-a70a-a141696c9395_LUKO_Homepage+Illustration_Mark+Conlan_Final+1.png?auto=compress%2Cformat);background-position:bottom;background-size:cover}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"container": "_uid__container___3eXZb",
	"heroContainer": "_uid__heroContainer___304k_",
	"inner": "_uid__inner___1SEg_",
	"innerSlices": "_uid__innerSlices___kGjrc",
	"title": "_uid__title___1Ntby",
	"bottomSection": "_uid__bottomSection___5OXj8"
};
module.exports = ___CSS_LOADER_EXPORT___;
